import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { api } from "@/lib/api";
import { Plus } from "lucide-react";
import { useState } from "react";
import UsuariosEdit from "./Usuarios-edit";
import UsuariosList from "./Usuarios-list";
import { Usuario } from "./interface/Usuario.interface";

const Usuarios = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [editingUser, setEditingUser] = useState<Usuario | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (user: Usuario) => {
    setEditingUser(user);
    setOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (confirm("Deseja realmente excluir este usuário?")) {
      try {
        await api.delete(`/api/usuario/${id}`);
        toast({
          title: "Sucesso",
          description: "Usuário excluído com sucesso!",
        });
        // Recarrega a lista
        setRefreshTrigger(prev => prev + 1);
      } catch (error: any) {
        console.error("Erro ao excluir usuário:", error);
        toast({
          title: "Erro",
          description: error.response?.data?.message || "Erro ao excluir usuário",
          variant: "destructive",
        });
      }
    }
  };

  const handleSuccess = () => {
    // Recarrega a lista após criar/atualizar
    setRefreshTrigger(prev => prev + 1);
    setOpen(false);
    setEditingUser(null);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-foreground">Usuários</h2>
            <p className="text-muted-foreground mt-1">Gerencie os usuários do sistema</p>
          </div>
          <Button 
            className="gap-2" 
            onClick={() => {
              setEditingUser(null);
              setOpen(true);
            }}
          >
            <Plus className="h-4 w-4" />
            Novo Usuário
          </Button>
        </div>

        <UsuariosList 
          onEdit={handleEdit}
          onDelete={handleDelete}
          refreshTrigger={refreshTrigger}
        />

        <UsuariosEdit
          open={open}
          onOpenChange={setOpen}
          usuario={editingUser}
          onSuccess={handleSuccess}
        />
      </div>
    </Layout>
  );
};

export default Usuarios;
